import React from 'react'
import GuranteeImg from '../../../assets/90-day-money-back.png'

import { icons } from '../../../constant/data'

const GuranteeLicence = () => {
    return (
        <div className='max-w-7xl mx-auto px-6 '>

        <div className=" bg-[#FAFCFF] p-6 rounded-2xl border shadow-lg relative">
            <div className="flex flex-col items-center text-center relative z-10">
                {/* <!-- Money Back Seal --> */}
                <div className="w-44 h-44 mb-6 flex justify-center">
                    <img src={GuranteeImg} alt="100% Money Back Guarantee Seal" className="md:w-44 md:h-44 w-36 h-36 object-contain hover:rotate-2 duration-300 ease-in-out hover:opacity-90"/>
                </div>

                {/* <!-- Headings --> */}
                <h2 className="md:text-4xl text-2xl font-bold text-gray-900 mb-2">
                    100% Satisfaction or Your Money Back
                </h2>
                <h3 className="md:text-3xl text-xl font-bold text-[#1e3a8a] mb-6">
            180-Day Guarantee
                </h3>

                {/* <!-- Description --> */}
                <p className="max-w-3xl text-gray-700 mb-10 text-lg leading-relaxed">
                We're Confident you'll love Respoclear Every bottle is backed by our ironclad 180-day guarantee. Whether you notice results in days or weeks, you’re covered. If you’re not satisfied, we’ll refund your full purchase—no questions asked.
                </p>
                <div className="flex justify-center items-center md:gap-2 gap-1">
                    {icons.map((icon, index) => (
                        <div
                            key={index}
                            className="md:w-20 md:h-20 h-12 w-12 rounded-full flex items-center justify-center p-0.5"
                        >
                            <div className="bg-white rounded-full w-full h-full flex items-center justify-center">
                                <img
                                    src={icon.src}
                                    alt={icon.alt}
                                    className="w-16 h-16 object-contain hover:opacity-90 duration-300 transition ease-in-out"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
        </div>


    )
}

export default GuranteeLicence
